import { Injectable } from '@angular/core';
import { CampaignInterface } from 'app/models/campaign.model';
import { DateRangeInterface } from 'app/modules/common/datetime/dateslots/dateslot.interface';
import {
  TimeslotInterface,
  TimeslotsCalendarInterface,
  WeeklySchedulingInterface,
} from 'app/modules/common/timeslot/timeslot.interface';
import { PlaylistItemInterface, PlaylistItemNestedInterface } from 'app/modules/editorial/editorial.interface';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';

@Injectable({
  providedIn: 'root',
})
export class CampaignDataTransformGet extends DataTransformAbstractGet {
  transform(campaign: CampaignInterface): CampaignInterface {
    // this._normalizeRange(campaign.range);
    this._normalizeResources(campaign);
    return campaign;
  }

  private _normalizeResources(campaign: CampaignInterface) {
    if (!Array.isArray(campaign.resources)) {
      return this;
    }
    campaign.resources.forEach((resourceInt: PlaylistItemInterface) => {
      this._normalizeTimeslots(resourceInt.timeslots);
      resourceInt.weeklyScheduling = this._normalizeWeeklySchedulings(resourceInt.weeklyScheduling);
      resourceInt.calendarScheduling = this._calendarSchedulings(resourceInt.calendarScheduling);

      this._normalizeNested(resourceInt.nested);
    });
    return this;
  }

  private _calendarSchedulings(calendarScheduling: TimeslotsCalendarInterface[]): TimeslotsCalendarInterface[] {
    if (!Array.isArray(calendarScheduling)) {
      return calendarScheduling;
    }
    calendarScheduling.forEach((calendar) => {
      if (calendar.startAt) {
        calendar.startAt = this.removeUTC(calendar.startAt.toString());
      }
      if (calendar.endAt) {
        calendar.endAt = this.removeUTC(calendar.endAt.toString());
      }
      calendar.weeklySchedulings = this._normalizeWeeklySchedulings(calendar.weeklySchedulings);
      calendar.timeslots = this._normalizeTimeslots(calendar.timeslots);
    });
    return calendarScheduling;
  }

  private _normalizeNested(nested: PlaylistItemNestedInterface) {
    if (nested) {
      if (!Array.isArray(nested.resources)) {
        return this;
      }
      nested.resources.forEach((resourceInt: PlaylistItemInterface) => {
        // this._normalizeRange(resourceInt.range);
        // THIS SHOULDN'T EXIST IN NESTED RESOURCES
        this._normalizeTimeslots(resourceInt.timeslots);
      });
    }
  }

  private _normalizeRange(range: DateRangeInterface[]) {
    if (!Array.isArray(range)) {
      return this;
    }
    range.forEach((rangeItem: DateRangeInterface) => {
      if (rangeItem.startAt) {
        rangeItem.startAt = this.removeUTC(rangeItem.startAt.toString());
      }
      if (rangeItem.endAt) {
        rangeItem.endAt = this.removeUTC(rangeItem.endAt.toString());
      }
    });
  }

  private _normalizeTimeslots(timeslots: TimeslotInterface[]) {
    if (!Array.isArray(timeslots)) {
      return timeslots;
    }
    timeslots.forEach((timeslot: TimeslotInterface) => {
      this._normalizeTimeslot(timeslot);
    });
    return timeslots;
  }

  private _normalizeTimeslot(timeslot: TimeslotInterface): TimeslotInterface {
    if (timeslot.from) {
      timeslot.from = this.removeUTC(timeslot.from.toString());
    }
    if (timeslot.to) {
      timeslot.to = this.removeUTC(timeslot.to.toString());
    }
    return timeslot;
  }

  private _normalizeWeeklySchedulings(weeklyScheduling: WeeklySchedulingInterface[]): WeeklySchedulingInterface[] {
    if (Array.isArray(weeklyScheduling)) {
      weeklyScheduling.forEach((day: WeeklySchedulingInterface) => {
        day.timeslots = this._normalizeTimeslots(day.timeslots);
      });
    }
    return weeklyScheduling;
  }
}
